import { useTranslation } from "react-i18next";

/**
 * A11y skip-link: first focusable element of a layout, visually hidden until
 * keyboard focus, jumps past the nav to the layout's `<main id={targetId}>`
 * (which must carry `tabIndex={-1}` so focus actually lands there).
 */
export function SkipLink({ targetId = "main-content" }: { targetId?: string }) {
  const { t } = useTranslation();
  return (
    <a
      href={`#${targetId}`}
      className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[100] focus:rounded-xl focus:border focus:border-border focus:bg-background focus:px-4 focus:py-2 focus:text-sm focus:text-foreground focus:shadow-lg"
    >
      {t("skip_to_content")}
    </a>
  );
}
